function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(-0.188)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.188)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.704 0.106)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H47.841V31.894H0Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H47.841V10.631H0Z",
  fill: "#ed2024",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,400H47.841v10.631H0Z",
  transform: "translate(0 -378.738)",
  fill: "#278e43",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.576,150l.6,4.054,1.766-3.7-.624,4.05,2.777-3.013-1.79,3.686,3.542-2.06-2.8,2.995,3.992-.925-3.555,2.037,4.087.293-4,.9,3.819,1.485-4.085-.32,3.212,2.544-3.809-1.509,2.319,3.378-3.2-2.565,1.221,3.912-2.3-3.393.013,4.1-1.2-3.92-1.2,3.92.013-4.1-2.3,3.393,1.221-3.912-3.2,2.565,2.319-3.378-3.809,1.509,3.212-2.544-4.085.32,3.819-1.485-4-.9,4.087-.293-3.555-2.037,3.992.925-2.8-2.995,3.542,2.06-1.79-3.686L305.8,154.4l-.624-4.05,1.766,3.7Z",
  transform: "translate(-283.655 -142.027)",
  fill: "#febd11",
  fillRule: "evenodd"
})));

function SvgKurdistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurdistan);
export default __webpack_public_path__ + "static/media/kurdistan.686b45e2.svg";
export { ForwardRef as ReactComponent };